<template>
  <div class="about">
    <b-embed
      aspect="16by9"
      src="https://player.vimeo.com/video/411578717?autoplay=1&loop=1&muted=1"
      allowfullscreen
    ></b-embed>
    <div class="down-arrow-container" @click="scrollToContainer">
      <downArrow></downArrow>
      <!-- <b-img class="down-arrow" fluid :src="down_arrow" alt="down arrow" @click="scrollToContainer" @mouseover="down_arrow = down_arrow_highlight" @mouseleave="down_arrow = down_arrow_static"></b-img> -->
    </div>
    <div id="contentContainer" class="container text-left mt-5">
      <div class="row spacer-lg"></div>
      <div class="row mt-2">
        <div class="col-10 mx-auto text-center">
          <h1 class="title">Example Projects</h1>
        </div>
      </div>
      <div class="row spacer-md"></div>
      <div class="row mt-3">
        <div
          class="col-lg-6 col-md-12 col-sm-12 d-flex flex-column justify-content-start p-3"
          v-for="(project, index) in projectLinks"
          :key="index"
        >
          <a
            v-if="project.name !== 'Daylight'"
            :href="project.link"
            class="about-page-link"
            title="go to project "
            target="_blank"
          >
            <b-img
              class="static"
              fluid
              :src="project.image"
              :alt="project.name + ' project in Scout'"
              @mouseover="project.image = project.image_gif"
              @mouseleave="project.image = project.static"
            ></b-img>
          </a>
          <div v-else>
            <b-img
              class="static"
              fluid
              :src="project.image"
              :alt="project.name + ' project in Scout'"
            ></b-img>
          </div>
          <div class="mt-4"></div>
          <!-- <p>
            {{project.description}}
          </p> -->
          <p v-html="project.description"></p>
        </div>
      </div>
      <div class="row spacer-md"></div>

      <hr />

      <div class="row spacer-md"></div>
      <div class="row mt-2">
        <div class="col-10 mx-auto text-center">
          <h1 class="title">Story of Scout</h1>
        </div>
      </div>
      <div class="row spacer-md"></div>
      <div class="row mt-3">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <p>
            Scout is a shared web platform that helps our global firm gain quick
            data-driven insights, present to clients, and engage with the
            community. Through Scout, designers and collaborators can easily
            explore and compare thousands of options, make more informed
            decisions, and enjoy the creative freedom of visualizing results in
            real time. By automating certain components of design, Scout frees
            focus for deeper development, innovation, and craft. It is software
            independent, easily accessible, and packages complex design
            scenarios into one click. Whether for two minutes or two hours,
            different types of users can coexist and get quick takeaways or
            obtain deep insights.
          </p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <p>
            Scout is developed by
            <a href="https://ui.kpf.com" target="_blank">KPF Urban Interface</a
            >, a research and design wing within
            <a href="https://www.kpf.com/" target="_blank"
              >Kohn Pedersen Fox Architects</a
            >, that engages with the contemporary issues that impact the future
            of our buildings and cities. KPFui uses spatial and temporal urban
            data analytics for informed decision making in the design of
            buildings and cities for people while engaging with some of the most
            critical contemporary urban topics: livability, sustainability, and
            mobility.
          </p>
          <p>
            We believe that smart cities & buildings are not about drones,
            sensors or autonomous vehicles. A truly smart city should leverage
            data to design better neighborhoods and utilize technology to make
            that data transparent and publicly accessible. We think people
            should be in control of technology and not the other way around.
          </p>
        </div>
      </div>

      <div class="row spacer-md"></div>
      <div class="row mt-2">
        <div class="col-10 mx-auto text-center">
          <h1 class="title">Accolades</h1>
        </div>
      </div>

      <div class="row spacer-md"></div>
      <div class="row">
        <div class="col-12">
          <div class="award-year">2020</div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="award-block">
            <div class="award-title-box">
              <div class="award-text-lg">Fast Company</div>
            </div>
            <div class="award-description-box d-flex">
              <div class="award-icon">
                <awardIcon :awardType="'award'" />
              </div>
              <div class="award-description">
                <a
                  href="https://www.fastcompany.com/90547352/scout-innovation-by-design-2020"
                  target="_blank"
                >
                  Winner of Innovation by Design Award: Data and Design Category
                </a>
              </div>
            </div>
            <div class=""></div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="award-block">
            <div class="award-text-lg">Document Journal</div>
            <div class="award-description-box d-flex">
              <div class="award-icon">
                <awardIcon :awardType="'bookmark'" />
              </div>
              <div class="award-description">
                Feature Article in 2020 fall publication
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row spacer-md"></div>
      <div class="row mt-2">
        <div class="col-10 mx-auto text-center">
          <h1 class="title">Contributors</h1>
        </div>
      </div>

      <div class="row spacer-md"></div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-12 col-sm-12 text-left">
          <h4 class="">Present</h4>
          <ul>
            <li
              v-for="(c, i) in contributorsSorted"
              :key="i"
              class="d-flex mb-2"
            >
              {{ c.firstName }} {{ c.lastName }}
            </li>
          </ul>
        </div>
        <div class="col-lg-6 col-md-6 col-12 col-sm-12 text-left">
          <h4 class="">Past</h4>
          <ul>
            <li
              v-for="(c, i) in previousContributorsSorted"
              :key="i"
              class="d-flex mb-2"
            >
              {{ c.firstName }} {{ c.lastName }}
            </li>
          </ul>
        </div>
      </div>
      <div class="row spacer-md"></div>
      <div class="row mt-2">
        <div class="col-10 mx-auto text-center">
          <h1 class="title">Tip of the Hat</h1>
        </div>
      </div>
      <div class="spacer-md"></div>
      <div class="row mt-2">
        <div class="col-12">
          <h4 class="">Huge Thanks</h4>
          <ul>
            <li>
              <a href="https://github.com/d3/d3" target="_blank">D3.js</a>
            </li>
            <li>
              <a href="https://github.com/mrdoob/three.js/" target="_blank"
                >Three.js</a
              >
            </li>
            <li>
              <a
                href="https://www.food4rhino.com/app/triceratops"
                target="_blank"
                >Triceratops</a
              >
            </li>
            <li>
              <a href="https://github.com/vuejs/vue" target="_blank">Vue.js</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row spacer-lg"></div>
    <div class="row mt-4">
      <div class="col-12 d-flex flex-column align-items-center">
        <a href="https://ui.kpf.com" target="_blank">
          <b-img :src="kpfuiLogo" height="25px" width="100%"></b-img>
        </a>
        <small class="m-2">© 2020 Kohn Pedersen Fox Associates </small>
      </div>
    </div>
  </div>
</template>
<script>
import downArrow from "@/assets/images/down_arrow.svg";

import awardIcon from "@/components/award-icon.vue";

export default {
  name: "about",
  components: {
    downArrow,
    awardIcon,
  },
  data() {
    return {
      kpfuiLogo: require("@/assets/images/kpfui_logo.png"),
      previousContributors: [
        {
          firstName: "Jason",
          lastName: "Danforth",
        },
        {
          firstName: " Amelia",
          lastName: "Harvey",
        },
        {
          firstName: "Nicholas",
          lastName: "Licalzi",
        },
        {
          firstName: "John",
          lastName: "Scheeler",
        },
        {
          firstName: "Jeff",
          lastName: "Drexel",
        },
        {
          firstName: "Angel Edgar",
          lastName: "Gomez",
        },
        {
          firstName: "Brandon",
          lastName: "Pachuca",
        },
        {
          firstName: "Snoweria",
          lastName: "Zhang",
        },
        {
          firstName: "Demi",
          lastName: "Chang",
        },
        {
          firstName: "Eric",
          lastName: "Pietraszkiewicz",
        },
      ],
      contributors: [
        {
          firstName: "Jordan",
          lastName: "Eggers",
        },
        {
          firstName: "Lucien",
          lastName: "Wilson",
        },
      ],
      projectLinks: [
        {
          link: "https://scout.kpfui.dev/?project=hangzhou",
          name: "Hangzhou",
          description:
            "Discover hundreds of “optimal” solutions that vary with block size.",
          static: require("@/assets/images/hangzhou_screen.png"),
          image: require("@/assets/images/hangzhou_screen.png"),
          image_gif: require("@/assets/images/hangzhou_scout.gif"),
        },
        {
          link: "https://scout.kpfui.dev/?project=hawaii",
          name: "Hawaiʻi",
          description: "Explore the future of housing development in Hawai’i.",
          static: require("@/assets/images/hawaii_screen.png"),
          image: require("@/assets/images/hawaii_screen.png"),
          image_gif: require("@/assets/images/hawaii_scout.gif"),
        },
        {
          link: "https://scout.kpfui.dev/?project=tampa",
          name: "Tampa",
          description:
            "Visualize the trade-offs among daylight, views, and efficiency.",
          static: require("@/assets/images/tampa_screen.png"),
          image: require("@/assets/images/tampa_screen.png"),
          image_gif: require("@/assets/images/tampa_scout.gif"),
        },
        {
          link: "https://daylight.scout.build",
          name: "Daylight",
          description:
            "Detailed daylight study for informing design of a high-performing facade.",
          static: require("@/assets/images/daylight_screen.png"),
          image: require("@/assets/images/daylight_screen.png"),
          image_gif: require("@/assets/images/daylight_scout.gif"),
        },
        {
          link: "https://scout.kpfui.dev/?project=Dice",
          name: "Dice",
          description:
            "Scout is not just for buildings. Explode a cube of Platonic solids!",
          static: require("@/assets/images/dice_screen.png"),
          image: require("@/assets/images/dice_screen.png"),
          image_gif: require("@/assets/images/dice.gif"),
        },
        {
          link: "https://leeside.kpfui.dev",
          name: "Leeside",
          description: `Prepare the fictional <a href='https://qz.com/1891446/welcome-to-leeside-the-uss-first-climate-haven/' target='_blank'>city of Leeside</a> for an influx of climate migrants.`,
          static: require("@/assets/images/leeside_screen.png"),
          image: require("@/assets/images/leeside_screen.png"),
          image_gif: require("@/assets/images/leeside.gif"),
        },
      ],
    };
  },
  computed: {
    contributorsSorted() {
      return this.sortByLastName(this.contributors);
    },
    previousContributorsSorted() {
      return this.sortByLastName(this.previousContributors);
    },
  },
  methods: {
    sortByLastName(contributors) {
      return [...contributors].sort((a, b) => {
        let nameA = a.lastName.toUpperCase();
        let nameB = b.lastName.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    },
    scrollToContainer() {
      var container = this.$el.querySelector("#contentContainer");
      var bb = container.getBoundingClientRect();

      window.scrollTo({
        top: bb.top + 100,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss">
$arrow-size: 35px;

video {
  position: relative;
  width: 100%;
  height: 100%;
  background: black;
  display: block;
  outline: none;
}

.down-arrow-container {
  position: absolute;
  margin: auto;
  top: 95vh;
  left: calc(50vw - #{$arrow-size});
  height: $arrow-size;
  width: $arrow-size;

  z-index: 10;
}

.down-arrow {
  animation: bounce 2s infinite ease-in-out;

  stroke: $white;
  &:hover {
    stroke-width: 4px;
    cursor: pointer;
  }
}
@keyframes bounce {
  0% {
    transform: translateY(0) scale(1);
  }
  25% {
    transform: translateY(-10px) scale(0.8);
  }
  55% {
    transform: translateY(0px) scale(1);
  }
}

hr {
  position: relative;
  border-color: $off-white;
  width: 200vw;
  left: -100vw;
}
.title {
  font-weight: 300;
  letter-spacing: 4px;
  font-size: 28px;

  text-transform: uppercase;
}
p {
  color: $off-white;
  text-align: justify;
}
.about-page-link > img {
  border-radius: 2px;
  border: 1px solid #414141;

  &:hover {
    border: 1px solid #aaa9aa;
  }
}
ul {
  padding-left: 0 !important;
  list-style: none;
}
.video-overlay {
  position: relative;
  top: 0;
  width: 100%;
  height: auto;
}
.about {
  background: $black;
  width: 100%;
  overflow-x: hidden;
}
.award-block {
  .award-text-lg {
    font-size: 3rem;
    font-weight: $font-bold;
  }

  .award-year {
    font-weight: $font-light;
    font-size: $font-sm;
  }

  a {
    color: $off-white !important;
    text-decoration: underline;

    &:hover {
      color: $highlight-color !important;
    }
  }

  .award-icon {
    margin-right: 10px;

    svg {
      height: 20px;

      path {
        fill: $off-white;
      }
    }
  }
}
</style>
